module.exports = __webpack_public_path__ + "62b31fc44e16b59bc819516e0a5b7fb8.svg";